import React, { useState, useEffect } from "react";
import { createEvent } from "../requests";
//import DatePicker from "../Components/DatePicker";
import DatePicker from "react-date-picker";
import { DynamicInput } from "../Edition/DynamicInput";
import regionByDepartement from "../Data/DepartmentRegion";
import GetOrganisation from "../Edition/GetOrganisation";
// import GetGeolocalisation from "../Components/GetLocationCoord";
import { loadOrganisations } from "../requests";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

const formData0 = {
  name_event: "",
  description: "",
  date: new Date(),
  city: "",
  department: 0,
  region: "",
  map_coord: "",
  organisation: [],
  races: [],
};

export const EventUpdate = (props) => {
  // to import existing record
  const eventRef = props.location.state ? props.location.state.eventRef : "";
  const dateIso = props.location.state
    ? new Date(
        Number(props.location.state.eventRef.date.slice(6, 10)),
        Number(props.location.state.eventRef.date.slice(3, 5)) - 1,
        Number(props.location.state.eventRef.date.slice(0, 2))
      )
    : new Date();

  // (0,2), (3,5), (6,10)
  // dateIso = moment(dateIso).format("YYYY-MM-DD hh:mm:ss");
  // dateIso = new Date(dateIso);

  const [formData, setFormData] = useState(eventRef ? eventRef : formData0);
  // use new date onChange
  const [date, setDate] = useState(dateIso || new Date());
  // select organisation
  const [orgaTri, setOrgaTri] = useState([]);

  const [selectedOrga, setSelectedOrga] = useState(
    formData && formData.organisation && formData.organisation[0]
      ? formData.organisation[0]
      : {}
  );

  useEffect(() => {}, [date]);

  // add field value
  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };
  // ADD RACE to formData from DynamicInput.jsc component
  const handleChangeArray = (object) => {
    let allRacesArray = Object.values(object);
    if (allRacesArray["_typename"]) {
      return delete allRacesArray["_typename"];
    }
    allRacesArray.map((item) => delete item.key);
    setFormData({
      ...formData,
      races: allRacesArray,
    });
  };

  // ADD / UPDATE ORGANISATION to formData
  const handleChangeOrganisation = (item) => {
    //const orgInfo = loadOrganisation(item);
    setFormData({
      ...formData,
      organisation: [item],
    });
  };

  // ORGANISATION fetch organisation on start
  const fetchDataOrg = async () => {
    try {
      const organisationsResult = await loadOrganisations("");

      setOrgaTri(organisationsResult);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOrganisation = async (org) => {
    setSelectedOrga(org);
  };

  useEffect(() => {
    fetchDataOrg();
  }, [orgaTri]);

  // ALL EVENT : get all values of form for each input
  const handleCompleteEvent = (e) => {
    e.preventDefault();
    // format items of object (type-value) or add item
    formData.id_organisateur = Number(selectedOrga.id);
    delete formData.organisation;
    if (formData["id"]) {
      return delete formData["id"];
    }
    formData["date"] = new Date(date);
    formData["department"] = Number(formData["department"]);
    formData["region"] = regionByDepartement[formData.department];
    formData.races.map((item) => {
      if (item["event_id"]) {
        return delete item["event_id"];
      }
      if (item["__typename"]) {
        return delete item["__typename"];
      }
      item["bibs"] != null
        ? (item["bibs"] = Number(item["bibs"]))
        : (item["bibs"] = null);
      item["Elevation_bike"] != null
        ? (item["Elevation_bike"] = Number(item["Elevation_bike"]))
        : (item["Elevation_bike"] = null);
      item["Elevation_run"] != null
        ? (item["Elevation_run"] = Number(item["Elevation_run"]))
        : (item["Elevation_run"] = null);
      if (item["id"]) {
        return delete item["id"];
      }
    });

    setFormData(formData);
    alert("alert1" + JSON.stringify(formData));
    fetchData();
  };

  const fetchData = async () => {
    try {
      const fullEvent = await createEvent(formData);

      fullEvent.races.map((item) => {
        if (item["__typename"]) {
          return delete item["__typename"];
        }
        if (formData["id"]) {
          return delete formData["id"];
        }
        if (formData["__typename"]) {
          return delete formData["__typename"];
        }
      });
      return fullEvent;
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="my-5">
      <h1 className="title text-warning my-md-3">
        Ajouter ou éditer une épreuve
      </h1>

      <div className="row box">
        <div className="col-lg-9">
          <form>
            <div className="row">
              <div className="col-md-4">
                <label className="label " htmlFor="validationDate">
                  Date
                </label>

                <DatePicker
                  // locale="fr"
                  onChange={setDate}
                  value={date}
                  className="input-group-text border-0 w-100 bg-primary"
                  dateFormat="DD/MM/YYYY HH:mm:ss"
                />
              </div>

              <div className="field col-md-6">
                <label className="label" htmlFor="validationName">
                  Nom de l'épreuve
                </label>
                <div className="control">
                  <input
                    id="validationName"
                    className="input"
                    type="text"
                    name="name_event"
                    value={formData.name_event}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>

              <div className="col-md-4">
                <Select
                  onChange={(e) => handleOrganisation(e)}
                  components={animatedComponents}
                  key={`key-org-${orgaTri}`}
                  options={orgaTri}
                  value={selectedOrga}
                  placeholder="Tous les clubs"
                  getOptionLabel={(options) => options["name_org"]}
                  getOptionValue={(options) => options["id"]}
                  defaultValue={orgaTri}
                />
              </div>

              <div className="field col-md-9">
                <label className="label" htmlFor="validationDescription">
                  Description
                </label>
                <div className="control">
                  <textarea
                    id="validationDescription"
                    className="input"
                    style={{ height: "6em" }}
                    name="description"
                    value={formData.description}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>

              <div className="col-md-4 field">
                <label className="label" htmlFor="validationCity">
                  Ville
                </label>
                <div className="control">
                  <input
                    id="validationCity"
                    className="input"
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>

              <div className="col-md-2 field">
                <label className="label" htmlFor="validationDepartment">
                  Département
                </label>
                <div className="control">
                  <input
                    id="validationDepartment"
                    className="input"
                    type="text"
                    name="department"
                    value={formData.department}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>

              <div className="col-md-2 field">
                <label className="label" htmlFor="validationRegion">
                  Région
                </label>
                <div className="control">
                  <input
                    id="validationRegion"
                    className="input"
                    type="text"
                    name="region"
                    value={
                      regionByDepartement[formData.department] ||
                      formData.region
                    }
                    //onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>

              <div className="col-md-4 field">
                <label className="label" htmlFor="validationmapCoord">
                  Coordonnées (lat., long.)
                </label>
                <div className="control">
                  <input
                    id="validationmapCoord"
                    className="input"
                    type="text"
                    name="map_coord"
                    value={formData.map_coord}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>

              <div className="col-md-12 mb-5">
                <DynamicInput
                  handleChangeArray={handleChangeArray}
                  formData={eventRef ? eventRef : []}
                  generalDate={date}
                  eventName={formData.name_event}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 field ">
                <div className="control">
                  <button
                    className="button bg-warning is-link"
                    onClick={(e) => handleCompleteEvent(e)}
                  >
                    Enregistrer
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <div className="ml-2">
            <h4 className="font-weight-bold">Sélectionner un organisateur</h4>
          </div>
          <GetOrganisation
            handleChangeOrganisation={handleChangeOrganisation}
            org={eventRef ? eventRef.organisation[0] : []}
          />
        </div>
      </div>
    </div>
  );
};

const distanceYouth = {
  youth6to9: "50, 1000,500",
  youth8to11: "100, 2000,1000",
  youth10to13: "200, 4000,1500",
  youth12to19: "300, 6000,2000",
};

const distanceAdult = {
  xXs: "200, 5, 1.5",
  xs: "400, 10,2.5",
  S: "750, 20,5",
  M: "1500, 40,10",
  L: "1900, 90,21",
  XL: "3000, 80,30",
  XXL: "3800, 180,42.2",
};
